var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAbstractShape(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1276,
    height: 714,
    viewBox: "0 0 1276 714",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M375.283 185.522C375.379 184.579 220.214 173.013 142.62 138.848L-2.39633 87.931L-2.39633 709.081C0.910918 709.781 4.29052 710.464 7.74025 711.13L213.995 711.13L375.283 711.13L1044.83 713.57C1048.59 715.078 1045.76 709.03 1275.76 624.518C1157.96 418.976 920.747 6.53982 914.348 1.12958C906.349 -5.63321 375.163 186.699 375.283 185.522Z",
    fill: "#F26522"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbstractShape);
export default __webpack_public_path__ + "static/media/AbstractShape.f1af92b071196dab9bd12b45d4213bcf.svg";
export { ForwardRef as ReactComponent };